const YANDEX_TRACKER = '98840135';
const MY_TRACKER = '3588247';

/** Отправка целей в счётчики веб-аналитики  */
export const reachGoal = (name: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  window?.ym?.(YANDEX_TRACKER, 'reachGoal', name);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  window?._tmr?.push({ id: MY_TRACKER, type: 'reachGoal', goal: name });
  return true;
};
